import { render, staticRenderFns } from "./registros.vue?vue&type=template&id=48d1a498"
import script from "./registros.vue?vue&type=script&lang=js"
export * from "./registros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports